import React from 'react';
import { BarChart, Bar, Cell, Tooltip, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { numberFormatter } from 'utils/tableUtils';
import _ from 'lodash';
import AnyaBarChartTooltip from './AnyaBarChartTooltip';

const getKeys = (data) => {
    if (!data || data.length === 0) return [];
    const keys = Object.keys(data[0]);
    const dataKeys = keys.filter(key => key !== 'name');
    return dataKeys;
}

const AnyaVisualizationBar = ({ showVisualization, visualisation, COLORS }) => {
    const chartData = visualisation?.data || [];

    if (!showVisualization || chartData.length === 0) return null;

    const dataKeys = getKeys(chartData);
    const newChartData = chartData.map(item => {
        if (item.hasOwnProperty('color')) {
          return _.omit(item, 'color');
        }
        return item;
      });

    const formatXAxisLabel = (value) => {
        if (!value) return '';
        const stringValue = String(value);
        if (stringValue.length > 10) {
            return `${stringValue.substring(0, 10)}...`;
        }
        return stringValue;
    };

    return (
        <div style={{ marginTop: 16, border: "1px solid #d9d9d9", borderRadius: "4px", width: 'fit-content', padding: "10px" }}>
            <h4>{visualisation.title}</h4>
            <ResponsiveContainer width={700} height={380}>
                <BarChart data={newChartData}>
                    <CartesianGrid stroke="#ccc" />
                    <XAxis 
                        dataKey="name" 
                        tickFormatter={formatXAxisLabel}
                        angle={-45}
                        textAnchor="end"
                        height={70}
                        interval={0}
                        tick={{ fontSize: 11, fill: '#666' }}
                    />
                    <YAxis tickFormatter={numberFormatter} />
                    {dataKeys.map((key, index) => (
                        <Bar key={index} dataKey={key} fill={COLORS[index % COLORS.length]}>
                            {chartData.map((entry, subIndex) => (
                                <Cell key={subIndex} fill={entry.color ? entry.color : COLORS[subIndex % COLORS.length]} />
                            ))}
                        </Bar>
                    ))}
                    <Tooltip content={<AnyaBarChartTooltip chartData={chartData} COLORS={COLORS} />} cursor={{ fill: 'transparent' }} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
};

export default AnyaVisualizationBar;

